"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreeStore = void 0;
const service_1 = require("@devim-front/service");
/**
 * Свободное хранилище. Свободное хранилище никак не контролирует количество
 * своих экземпляров и способ их получения.
 */
class FreeStore extends service_1.FreeService {
}
exports.FreeStore = FreeStore;
